module.exports = __webpack_public_path__ + "noImage140-b3b15.jpg";